import type { PanelTabProps } from './PanelTab';
import type { PanelTabsComponentProps, PanelTabsProps } from './PanelTabs';

export interface OldPanelTabProps extends Omit<PanelTabProps, 'onTabSelect' | 'unit' | 'renderHelperIcon' | 'status'> {
  /** @deprecated unit을 대신 사용해주세요. */
  suffix: string;
  /** @deprecated onTabSelect를 대신 사용해주세요. */
  onClick?: PanelTabProps['onTabSelect'];
  /** @deprecated status를 대신 사용해주세요. */
  highlight?: boolean;
  /** @deprecated renderHelperIcon을 대신 사용해주세요. */
  helperIcon?: PanelTabProps['renderHelperIcon'];
}

export function convertOldPanelTabProps(props: OldPanelTabProps): PanelTabProps {
  const { onClick, highlight, suffix, helperIcon, ...restProps } = props;

  return {
    ...restProps,
    onTabSelect: onClick,
    status: highlight ? 'warning' : null,
    unit: suffix,
    renderHelperIcon: helperIcon,
  };
}

export interface OldPanelTabsProps extends Omit<PanelTabsProps, 'hasDivider'> {
  /** @deprecated hasDivider를 대신 사용해주세요. */
  divider?: boolean;
}

export type OldPanelTabsComponentProps = React.PropsWithChildren<OldPanelTabsProps>;

export function convertOldPanelTabsProps(props: OldPanelTabsComponentProps): PanelTabsComponentProps {
  const { divider, ...restProps } = props;

  return {
    ...restProps,
    hasDivider: divider,
  };
}
